import { createReducer, on } from '@ngrx/store';
import {
  MENU_FIND_SUCCESS,
  MENU_FAILURE,
  MENU_RESET,
  MENU_FIND_ALL_SUCCESS,
  MENU_CLEAR_STATE,
  MENU_UPDATE_LOADING,
} from '../actions';
import { IResponseBadRequest } from '@core/interfaces';
import { Menu } from '@core/models';

export interface MenuState {
  loading: boolean;
  menu: Menu | null;
  menuId: string | null;
  menuList: Menu[] | null;
  error: IResponseBadRequest | null;
}

export const initialState: MenuState = {
  loading: false,
  menu: null,
  menuId: null,
  menuList: null,
  error: null,
};

export const menuReducer = createReducer(
  initialState,
  on(MENU_FIND_SUCCESS, (state, { menu }) => ({ ...state, menu })),
  on(MENU_FIND_ALL_SUCCESS, (state, { menuList }) => ({ ...state, menuList })),
  on(MENU_FAILURE, (state, { error }) => ({ ...state, error })),
  on(MENU_RESET, (state) => ({ ...state, menu: null })),
  on(MENU_CLEAR_STATE, () => initialState),
  on(MENU_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading }))
);
